import { Table } from 'antd';
import { calculateColumnsWidth } from 'api/common';
import { LoadingScreen } from 'common/components';
import { createContext, useEffect, useState } from 'react';
import FilterColumns from './FilterColumns';
import { NachPagedList, getNachList, FilterPayload } from 'api/nach';

let payPagedList: NachPagedList = { currentPageIndex: 1, noOfRecords: 10, data: [] };

type Props = {
  filter: FilterPayload;
};

export const NachDashboardRetryContext = createContext<any>(null);

const FilteredList = ({ filter }: Props) => {
  const [pagedList, setPagedList] = useState(payPagedList);
  const [isLoading, setIsLoading] = useState(false);
  const [isRetry, setIsRetry] = useState(false);

  // filter.username = sessionStorage.getItem('user')?.toString();
  const isAdmin = sessionStorage.getItem('isAdmin');

  // if (isAdmin != 'true') {
  //   filter.sourceApplicationName = sessionStorage.getItem('source')?.toString();
  // }

  useEffect(() => {
    setIsLoading(false);
    setPagedList(payPagedList);

    // Create an isolated copy 
    const payload = { ...filter };

    // Cleanly apply the properties to the copy only
    if (isAdmin !== 'true') {
      payload.sourceApplicationName = sessionStorage.getItem('source')?.toString();
    }
    //console.log('nach dashboard filter', filter);
    // filter.pageNo = 1;
    // filter.pageSize = 10;
    // filter.isExtract = false;
    console.log('nach dashboard filter', payload);
    payload.pageNo = 1;
    payload.pageSize = 10;
    payload.isExtract = false;

    getNachList(payload)
      .then((res) => {
        if (res.data) {
          setPagedList(res.data);
        }
        console.log('nach dashboard', res);
      })
      .finally(() => {
        setIsLoading(true);
      });
    //}, [filter, isRetry]);
  }, [JSON.stringify(filter), isRetry, isAdmin]);

  if (!isLoading) {
    return <LoadingScreen />;
  }

  const handleChange = (_pagination: any, _filters: any, sorter: any) => {
    if (sorter.hasOwnProperty('column')) {
      // params.order = { field: sorter.field, dir: sorter.order };
    }
    setIsLoading(false);
    filter.isExtract = false;
    // filter.username = sessionStorage.getItem('user')?.toString();
    if (isAdmin != 'true') {
      filter.sourceApplicationName = sessionStorage.getItem('source')?.toString();
    }

    filter.pageNo = _pagination.current;
    filter.pageSize = _pagination.pageSize;
    getNachList(filter)
      .then((res) => {
        if (res.data) {
          setPagedList(res.data);
        }
      })
      .finally(() => {
        setIsLoading(true);
      });
  };

  const maxWidthPerCell = 600;

  const dataTable = calculateColumnsWidth(FilterColumns, pagedList?.data || [], maxWidthPerCell);
  const tableHeight = 500;
  const rowKey = 'ROWNUM';

  return (
    <NachDashboardRetryContext.Provider value={{ setIsRetry, isRetry }}>
      <Table
        dataSource={dataTable.source}
        columns={dataTable.columns}
        rowKey={rowKey}
        pagination={{
          pageSize: 10,
          total: pagedList?.noOfRecords,
          current: pagedList?.currentPageIndex == 0 ? 1 : pagedList?.currentPageIndex,
        }}
        scroll={{ x: dataTable.tableWidth, y: tableHeight }}
        onChange={handleChange}
      />
    </NachDashboardRetryContext.Provider>
  );
};

export default FilteredList;
